import {
  PROCESSES_ERROR,
  PROCESSES_REQUEST,
  PROCESSES_RESET,
  PROCESSES_SUCCESS,
} from "./ActionType";

export const initialState = {
  isRequest: false,
  isSuccess: false,
  isError: false,
  data: null,
  error: null,
  shopId: null,
  requestId: null,
};

const hasRequestMeta = (meta) =>
  typeof meta?.shopId === "string" &&
  meta.shopId.length > 0 &&
  typeof meta?.requestId === "string" &&
  meta.requestId.length > 0;

const isActiveRequest = (state, meta) =>
  hasRequestMeta(meta) &&
  state.shopId === meta.shopId &&
  state.requestId === meta.requestId;

const processesReducer = (state = initialState, action) => {
  switch (action.type) {
    case PROCESSES_REQUEST:
      if (!hasRequestMeta(action.meta)) return state;
      return {
        isRequest: true,
        isSuccess: false,
        isError: false,
        data: null,
        error: null,
        shopId: action.meta.shopId,
        requestId: action.meta.requestId,
      };
    case PROCESSES_SUCCESS:
      if (!isActiveRequest(state, action.meta)) return state;
      return {
        ...state,
        isRequest: false,
        isSuccess: true,
        isError: false,
        data: action.payload,
        error: null,
      };
    case PROCESSES_ERROR:
      if (!isActiveRequest(state, action.meta)) return state;
      return {
        ...state,
        isRequest: false,
        isSuccess: false,
        isError: true,
        data: null,
        error: action.payload,
      };
    case PROCESSES_RESET:
      if (
        action.meta?.shopId !== undefined &&
        state.shopId !== String(action.meta.shopId)
      ) {
        return state;
      }
      return initialState;
    default:
      return state;
  }
};

export default processesReducer;
